import { render, staticRenderFns } from "./avalonNewsEditor.vue?vue&type=template&id=2c1d54e2&scoped=true&"
import script from "./avalonNewsEditor.vue?vue&type=script&lang=js&"
export * from "./avalonNewsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d54e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSheet,VTextarea})
